(function () {
  angular
    .module("akitabox.core.services.tagCategoryValue", [
      "akitabox.constants",
      "akitabox.core.services.http",
    ])
    .factory("TagCategoryValueService", TagCategoryValueService);

  /** @ngInject */
  function TagCategoryValueService(models, HttpService) {
    var service = {
      // Create
      create: create,
      // Retrieve
      get: get,
      getAll: getAll,
      getById: getById,
      // Delete
      remove: remove,
    };

    return service;

    // ------------------------
    //   Private Functions
    // ------------------------

    function buildBaseRoute(buildingId, categoryId) {
      var buildingUri = "/" + models.BUILDING.ROUTE_PLURAL + "/" + buildingId;
      return (
        buildingUri +
        "/" +
        models.TAG_CATEGORY.ROUTE_PLURAL +
        "/" +
        categoryId +
        "/" +
        models.TAG_CATEGORY_VALUE.ROUTE_PLURAL
      );
    }

    function buildDetailRoute(buildingId, categoryId, valueId) {
      return buildBaseRoute(buildingId, categoryId) + "/" + valueId;
    }

    function buildListRoute(buildingId, categoryId) {
      return buildBaseRoute(buildingId, categoryId);
    }

    // ------------------------
    //   Public Functions
    // ------------------------

    /******************* *
     *   Create
     * ****************** */

    function create(buildingId, tagId, data) {
      var route = buildListRoute(buildingId, tagId);
      return HttpService.create(route, data);
    }

    /******************* *
     *   Delete
     * ****************** */

    function get(buildingId, tagId, params) {
      var route = buildListRoute(buildingId, tagId);
      return HttpService.get(route, params);
    }

    function getAll(buildingId, tagId, params) {
      var route = buildListRoute(buildingId, tagId);
      return HttpService.getAll(route, params);
    }

    function getById(buildingId, tagId, tagValueId, params) {
      var route = buildDetailRoute(buildingId, tagId, tagValueId);
      return HttpService.getById(route, tagValueId, params);
    }

    /******************* *
     *   Delete
     * ****************** */

    function remove(buildingId, tagId, tagValueId) {
      var route = buildDetailRoute(buildingId, tagId, tagValueId);
      return HttpService.remove(route);
    }
  }
})();
